import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import API from '../../services/api';

const DevisesAdmin = () => {
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [newRate, setNewRate] = useState('');
  const [saving, setSaving] = useState(false);

  const fetchCurrencies = async () => {
    setLoading(true);
    try {
      const res = await API.get('/admin/currencies');
      setCurrencies(res.data.currencies || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchCurrencies(); }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await API.put(`/admin/currencies/${modal.id}`, { rate: newRate });
      await fetchCurrencies();
      setModal(null);
    } catch (e) { console.error(e); }
    finally { setSaving(false); }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh', color: '#94a3b8', flexDirection: 'column', gap: 12 }}>
        <i className="fas fa-spinner fa-spin" style={{ fontSize: 28, color: '#3b82f6' }}></i>
        <span>Chargement...</span>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8, padding: '8px 14px', display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#64748b' }}>
          <i className="fas fa-info-circle" style={{ color: '#3b82f6' }}></i>
          Taux de change stockés en base de données
        </div>
        <button className="admin-btn-secondary" onClick={fetchCurrencies}>
          <i className="fas fa-sync-alt"></i> Actualiser
        </button>
      </div>

      {/* Table */}
      <div className="admin-table-card">
        <table className="admin-table">
          <thead>
            <tr>
              <th>De</th>
              <th>Vers</th>
              <th>Taux</th>
              <th>Mis à jour</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currencies.map(cur => (
              <tr key={cur.id}>
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{ width: 32, height: 32, borderRadius: 6, background: '#eef2ff', color: '#3b82f6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 10 }}>
                      {cur.from_currency}
                    </div>
                    <strong>{cur.from_currency}</strong>
                  </div>
                </td>
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{ width: 32, height: 32, borderRadius: 6, background: '#f0fdf4', color: '#10b981', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 10 }}>
                      {cur.to_currency}
                    </div>
                    <strong>{cur.to_currency}</strong>
                  </div>
                </td>
                <td>
                  <strong style={{ fontSize: 16 }}>{parseFloat(cur.rate).toFixed(4)}</strong>
                  <span style={{ fontSize: 12, color: '#64748b', marginLeft: 8 }}>1 {cur.from_currency} = {parseFloat(cur.rate).toFixed(4)} {cur.to_currency}</span>
                </td>
                <td style={{ fontSize: 12, color: '#94a3b8' }}>{new Date(cur.created_at).toLocaleString('fr')}</td>
                <td>
                  <button className="admin-btn-icon" title="Modifier taux" onClick={() => { setNewRate(cur.rate); setModal(cur); }}>
                    <i className="fas fa-edit"></i>
                  </button>
                </td>
              </tr>
            ))}
            {currencies.length === 0 && (
              <tr><td colSpan={5} style={{ textAlign: 'center', color: '#94a3b8', padding: '30px 0' }}>Aucune devise configurée</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Edit Modal */}
      <AnimatePresence>
        {modal && (
          <motion.div className="admin-modal-overlay" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={e => e.target === e.currentTarget && setModal(null)}>
            <motion.div className="admin-modal" initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.9, opacity: 0 }}>
              <div className="admin-modal-header">
                <h2>Modifier le taux — {modal.from_currency}/{modal.to_currency}</h2>
                <button className="admin-modal-close" onClick={() => setModal(null)}><i className="fas fa-times"></i></button>
              </div>
              <p style={{ fontSize: 13, color: '#64748b', marginBottom: 20 }}>
                Taux actuel : <strong>1 {modal.from_currency} = {parseFloat(modal.rate).toFixed(4)} {modal.to_currency}</strong>
              </p>
              <div className="admin-form-group">
                <label>Nouveau taux</label>
                <input
                  className="admin-form-input"
                  type="number"
                  step="0.0001"
                  value={newRate}
                  onChange={e => setNewRate(e.target.value)}
                />
              </div>
              <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: 12, fontSize: 12, color: '#92400e', marginBottom: 16 }}>
                <i className="fas fa-exclamation-triangle" style={{ marginRight: 6 }}></i>
                Cette modification est enregistrée dans la base de données et affecte toutes les transactions futures.
              </div>
              <div className="admin-modal-actions">
                <button className="btn-accept" onClick={handleSave} disabled={saving}>{saving ? 'En cours...' : 'Enregistrer le taux'}</button>
                <button className="btn-cancel" onClick={() => setModal(null)}>Annuler</button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default DevisesAdmin;
